import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderComponent } from './header.component';
import { LanguageDropDownModule } from '../language-drop-down/language-drop-down.module';
import { MatIconModule } from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import { UserMenuModule } from '../user-menu/user-menu.module';

@NgModule({
  imports: [
    CommonModule,
    LanguageDropDownModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    UserMenuModule
  ],
  declarations: [
    HeaderComponent,
  ],
  exports : [
    HeaderComponent,
  ]
})

export class HeaderModule { }
